import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import CaseCard from "@/components/feature/CaseCard";
import { cases } from "@/mocks/cases";
import { getLatestCases } from "@/utils/cases";

const hotTags = ["装修", "合同陷阱", "预付费", "招聘", "借贷", "评价体系", "招投标", "消费贷"];

export default function LatestSection() {
  const latest = getLatestCases(6);
  const editorsPick = cases.find((item) => item.id === "bidding-companion");

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1240px] mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-8">
            <SectionHeading
              eyebrow="最新上架"
              title="刚刚整理的调查笔记"
              desc="按发布时间排序，每周更新 2 到 3 篇。"
            />
            <div>
              {latest.map((item, index) => (
                <CaseCard key={item.id} item={item} variant="compact" index={index} />
              ))}
            </div>
            <Link
              to="/cases"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              浏览完整档案库
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <aside className="lg:col-span-4 space-y-5">
            {editorsPick && (
              <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                <div className="px-5 py-3 bg-foreground-950 flex items-center gap-2">
                  <i className="ri-bookmark-3-line text-accent-400" aria-hidden="true"></i>
                  <span className="text-sm font-medium text-background-50">编辑推荐</span>
                </div>
                <Link to={`/cases/${editorsPick.id}`} className="block group">
                  <div className="relative aspect-[16/9] overflow-hidden bg-secondary-900">
                    <img
                      src={editorsPick.cover}
                      alt={editorsPick.coverAlt}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5">
                    <p className="text-xs text-primary-600 mb-2">{editorsPick.categoryLabel}</p>
                    <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                      {editorsPick.title}
                    </h3>
                    <p className="mt-2 text-xs text-foreground-500">
                      {editorsPick.author} ｜ {editorsPick.readTime}
                    </p>
                  </div>
                </Link>
              </div>
            )}

            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-price-tag-3-line text-primary-600" aria-hidden="true"></i>
                热门标签
              </h3>
              <div className="flex flex-wrap gap-2">
                {hotTags.map((tag) => (
                  <Link
                    key={tag}
                    to={`/cases?q=${encodeURIComponent(tag)}`}
                    className="px-3 py-1.5 rounded-md bg-background-100 text-foreground-700 text-xs hover:bg-primary-100 hover:text-primary-800 transition-colors"
                  >
                    #{tag}
                  </Link>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl mb-4">
                <i className="ri-quill-pen-line" aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                你遇到过类似的环节吗
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                把你签过的字、收到的报价、听过的原话告诉我们，我们会做匿名处理。
              </p>
              <Link
                to="/about#submit"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800"
              >
                提供爆料线索
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}